"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appCodes = exports.httpCodes = void 0;
exports.httpCodes = {
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    METHOD_NOT_ALLOWED: 405,
    CONFLICT: 409,
    TOO_MANY_REQUESTS: 429,
    INTERNAL_ERROR: 500,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
};
exports.appCodes = {
    NO_AUTH_SESSION: "NO_AUTH_SESSION",
    USER_NOT_FOUND: "USER_NOT_FOUND",
    INVALID_DOMAIN: "INVALID_DOMAIN",
    INVALID_VERSION: "INVALID_VERSION",
    INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
    ENTITY_NOT_FOUND: "ENTITY_NOT_FOUND",
};
//# sourceMappingURL=consts.js.map